export const EMobileUsersFlatsStatus = {
  PENDING_INVITATION: 0,
  PENDING_APPROVAL: 1,
  ACCEPTED: 2,
  DECLINED: 3
}
